import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import authRoutes from '../routes/authroutes.js';
import { AuthRecaptchaProvider } from '../utils/recaptchaProvider';

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;


class Blanklayout extends React.Component {
  componentDidMount() {
    document.body.classList.add('auth-recaptcha-active');
  }

  componentWillUnmount() {
    document.body.classList.remove('auth-recaptcha-active');
  }

  render() {
    return (
      <AuthRecaptchaProvider siteKey={RECAPTCHA_SITE_KEY}>
        <div className="authentications">
          <Switch>
            {authRoutes.map((prop, key) => {
              if (prop.redirect)
                return (
                  <Redirect from={prop.path} to={prop.pathTo} key={key} />
                );
              return (
                <Route path={prop.path} component={prop.component} key={key} />
              );
            })}
          </Switch>
          <div id="recaptcha-container" />
        </div>
      </AuthRecaptchaProvider>
    )
  }
}
export default Blanklayout;
